import { BaseWizardStep } from '../base.wizard.step';

import { ApiService } from '@nrwl/common-lib';

export class SyslogConfigWizardStep extends BaseWizardStep {
  addNewItemCallback: any;
  methodTypeSource: any;
  selectedMethod: any;
  gigaStorData: any;
  selectedDataSource: any;
  dataSourceSelected = false;
  constructor(apiService: ApiService, config: any, parent: any) {
    super(apiService, config, parent);
    if (this.config.def.subContent) {
      this.subContent = new SyslogConfigWizardStep(
        apiService,
        config.def.subContent,
        this
      );
    }
  }
}
